/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Show_ShadowInputs */

const fr_label_show_shadow = /** @type {(inputs: Label_Show_ShadowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ombre portée`)
};

const en_label_show_shadow = /** @type {(inputs: Label_Show_ShadowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Box shadow`)
};

/**
* | output |
* | --- |
* | "Box shadow" |
*
* @param {Label_Show_ShadowInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const label_show_shadow = /** @type {((inputs?: Label_Show_ShadowInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Show_ShadowInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_label_show_shadow(inputs)
	return en_label_show_shadow(inputs)
});